import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { appendQuery, combine } from 'src/app/shared/utilities/route';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { WeeklyPayResponseModel } from '../quick-quote/services/quick-quote.service';
import { FetchArgs, PagingToken } from 'src/app/shared/models/core';
import { ImportMarginGridData } from './direct-offer-Import-margin-grid-data.model';
import { DirectOfferMarginModel } from './direct-offer-create-margin.model';

@Injectable({
    providedIn: 'root'
})
export class DirectOfferMarginService {
    private readonly coreApiPath: string;

    constructor(private readonly _httpClient: HttpClient, @Inject(APP_CONFIG) settings: Settings) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    getWeeklyPayQuote(
        directOfferMarginRequest: DirectOfferMarginModel,
        offerId: number
    ): Observable<WeeklyPayResponseModel> {
        const body = directOfferMarginRequest;
        return this._httpClient.post<WeeklyPayResponseModel>(
            `${this.coreApiPath}/candidate-offer/recruiting/${offerId}/quote`,
            body
        );
    }

    createDirectOfferMargin(directOfferMarginRequest: DirectOfferMarginModel, offerId: number): Observable<number> {
        const body = directOfferMarginRequest;
        return this._httpClient.post<number>(`${this.coreApiPath}/candidate-offer/recruiting/${offerId}/margin`, body);
    }

    createDirectOfferMarginViaImport(offerId: number, importFromMarginId: number): Observable<number> {
        return this._httpClient.post<number>(
            `${this.coreApiPath}/candidate-offer/recruiting/${offerId}/import-margin/${importFromMarginId}`,
            null
        );
    }

    getImportMarginGridGridData(args: FetchArgs): Observable<PagingToken<ImportMarginGridData[]>> {
        const url = `${this.coreApiPath}/candidate-offer/recruiting/import-margins`;
        const params = {};

        if (args.filter) {
            for (const prop in args.filter) {
                if (prop === 'expertiseId') {
                    params[`filter.expertiseIds`] = args.filter[prop];
                } else {
                    params[`filter.${prop}`] = args.filter[prop];
                }
            }
        }

        if (args.sort && args.sort.field && args.sort.field.length) {
            params['sort.field'] = args.sort.field;
            params['sort.type'] = args.sort.dir || 'asc';
        }

        return this.getPaged(args.pageSize, args.skip, url, params);
    }

    private getPaged<T>(pageSize: number, skip: number, url: string, params: any): Observable<PagingToken<T[]>> {
        const path = appendQuery(url, `pageSize=${pageSize}`, `skip=${skip}`);
        return this._httpClient.get<PagingToken<T[]>>(path, { params });
    }
}
